import { usePathContext } from "../PathInfo";
import React, { useMemo } from "react";
import { ConditionalCheck } from "./ConditionalCheck";
import { AddingCheckControl } from "./AddingCheckControl";
import { buildConditionedPath } from "./HelpersConditional";
import { useConditionalContext } from "./ConditionalContext";

interface ConditionalDisplayProps {
  value: object | undefined;
}

export function ConditionalDisplay(props: ConditionalDisplayProps) {
  const { path } = usePathContext();
  const { selectedCondition, conditions, unconditionedName } = useConditionalContext();

  let conditionArray: any[] = [];

  const conditionedPropName = useMemo(() => {
    return buildConditionedPath(selectedCondition!, unconditionedName, conditions!, "condition");
  }, [selectedCondition, unconditionedName, conditions]);

  if (props.value === undefined) {
    return (
      <AddingCheckControl conditionArray={conditionArray} allChecks={{}} path={path.concat(conditionedPropName)} />
    );
  }

  const objectEntries = Object.entries(props.value);

  for (let i = 0; i < objectEntries.length; i++) {
    conditionArray.push(objectEntries[i]);
  }

  return (
    <>
      {conditionArray.map((condition, index) => {
        return (
          <ConditionalCheck
            key={path.join() + index + condition.toString()}
            keyValue={condition[0]}
            value={condition[1]}
            allConditions={props.value!}
            path={path.concat(conditionedPropName)}
            index={index}
          />
        );
      })}

      <AddingCheckControl
        conditionArray={conditionArray}
        allChecks={props.value!}
        path={path.concat(conditionedPropName)}
      />
    </>
  );
}
